var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewalLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_1898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 8.33333C2.31636 5.15341 4.72428 2.60777 7.83844 1.74148C8.09985 1.66876 8.23055 1.6324 8.30095 1.7103C8.37138 1.7882 8.31949 1.91702 8.21577 2.17463L7.49996 3.75M11.6666 1.66667C14.8465 2.3164 17.3922 4.72432 18.2585 7.83848C18.3312 8.09989 18.3675 8.23059 18.2896 8.30099C18.2118 8.37142 18.083 8.31953 17.8253 8.21581L16.25 7.5M18.3333 11.6667C17.6835 14.8466 15.2756 17.3923 12.1615 18.2585C11.9 18.3313 11.7694 18.3676 11.699 18.2897C11.6285 18.2118 11.6805 18.083 11.7841 17.8253L12.5 16.25M8.33329 18.3333C5.15337 17.6836 2.60773 15.2757 1.74143 12.1615C1.66872 11.9001 1.63236 11.7694 1.71026 11.699C1.78816 11.6286 1.91698 11.6805 2.17459 11.7842L3.74996 12.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17744 9.72058L10.0934 5.97772C10.3215 5.68499 10.7489 5.86718 10.7489 6.25711V9.15417C10.7489 9.38775 10.9165 9.57708 11.1233 9.57708H12.5415C12.8637 9.57708 13.0355 10.0062 12.8226 10.2794L9.90671 14.0222C9.67862 14.315 9.25121 14.1328 9.25121 13.7429V10.8458C9.25121 10.6122 9.08354 10.4229 8.87679 10.4229H7.45852C7.13634 10.4229 6.9646 9.99383 7.17744 9.72058Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_1898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewalLight);
export default __webpack_public_path__ + "static/media/renewal_light.79159edb738f0e7590f2fe37c71c8111.svg";
export { ForwardRef as ReactComponent };